import * as React from 'react';
import { connect } from 'react-redux';
import { ButtonCheckbox } from '../../../../common/components/button_checkbox';
import { IAppState, Dispatch } from '../../../../common/state';
import { changeBalcony, changeLoggia } from '../../../state/advanced/balconies';
import { InlineParam, Row } from '../markup';

export interface IBalconiesProps {
  hasBalcony: boolean;
  onBalconyChanged(value: boolean): void;

  hasLoggia: boolean;
  onLoggiaChanged(value: boolean): void;
}

export const balconies: React.StatelessComponent<IBalconiesProps> = props => (
  <Row title="Балкон">
    <InlineParam>
      <ButtonCheckbox onValueChange={value => props.onBalconyChanged(value)} value={props.hasBalcony}>
        Есть балкон
      </ButtonCheckbox>
    </InlineParam>

    <InlineParam>
      <ButtonCheckbox onValueChange={value => props.onLoggiaChanged(value)} value={props.hasLoggia}>
        Есть лоджия
      </ButtonCheckbox>
    </InlineParam>
  </Row>
);

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    hasBalcony: (state.filters.jsonQuery.balconies && !!state.filters.jsonQuery.balconies.value.gte) || false,
    hasLoggia: (state.filters.jsonQuery.loggia && state.filters.jsonQuery.loggia.value) || false,
  }),
  (dispatch: Dispatch) => ({
    onBalconyChanged: (value: boolean) => {
      dispatch(changeBalcony(value));
    },
    onLoggiaChanged: (value: boolean) => {
      dispatch(changeLoggia(value));
    },
  }),
)(balconies);
